module.exports = __webpack_public_path__ + "img/thumbnail_size-small.43ec5117.svg";